import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const DataWrapStyled = styled(FlexContainer)`
  margin-top: 1rem;
  img {
    margin-right: 1.5rem;
  }
`;
